import React from 'react';

const SevenFeatures = () => {
  return (
    <section className="py-32 bg-background" id="features" data-testid="features-section">
      <div className="max-w-container-max mx-auto px-margin-desktop">
        <div className="mb-20 text-center">
          <h2 className="font-headline-lg text-headline-lg text-primary mb-4">7 Powerful Features</h2>
          <p className="font-body-md text-body-md text-on-surface-variant">Built for precision, designed for growth.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-gutter">

          {/* Feature 1: Large */}
          <div className="md:col-span-8 group bg-surface-container-lowest p-card-padding rounded-2xl executive-border card-hover transition-all duration-300" data-testid="feature-voice-entry">
            <div className="w-12 h-12 rounded-lg bg-surface-container-high flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-background transition-colors">
              <span className="material-symbols-outlined">mic</span>
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-4">Voice Entry</h3>
            <p className="font-body-md text-body-md text-on-surface-variant leading-relaxed mb-6">
              Record sales, update stock, or add customer credit just by speaking. CONSAI's advanced NLP understands business context instantly.
            </p>
            <div className="flex gap-4">
              <span className="px-3 py-1 rounded-full bg-surface-container-high text-label-caps text-on-surface-variant">HINDI SUPPORT</span>
              <span className="px-3 py-1 rounded-full bg-surface-container-high text-label-caps text-on-surface-variant">REAL-TIME</span>
            </div>
          </div>

          {/* Feature 2: Small */}
          <div className="md:col-span-4 group bg-surface-container-lowest p-card-padding rounded-2xl executive-border card-hover transition-all duration-300" data-testid="feature-stock">
            <div className="w-12 h-12 rounded-lg bg-surface-container-high flex items-center justify-center mb-6">
              <span className="material-symbols-outlined">inventory_2</span>
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-4">Manage Sales/Stock</h3>
            <p className="font-body-md text-body-md text-on-surface-variant">Intelligent inventory tracking that alerts you before items run out.</p>
          </div>

          {/* Feature 3 */}
          <div className="md:col-span-4 group bg-surface-container-lowest p-card-padding rounded-2xl executive-border card-hover transition-all duration-300" data-testid="feature-ai-suggestions">
            <div className="w-12 h-12 rounded-lg bg-surface-container-high flex items-center justify-center mb-6">
              <span className="material-symbols-outlined">insights</span>
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-4">Daily AI Suggestions</h3>
            <p className="font-body-md text-body-md text-on-surface-variant">Wake up to actionable insights about your best-selling products.</p>
          </div>

          {/* Feature 4 */}
          <div className="md:col-span-4 group bg-surface-container-lowest p-card-padding rounded-2xl executive-border card-hover transition-all duration-300" data-testid="feature-reports">
            <div className="w-12 h-12 rounded-lg bg-surface-container-high flex items-center justify-center mb-6">
              <span className="material-symbols-outlined">description</span>
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-4">AI Business Reports</h3>
            <p className="font-body-md text-body-md text-on-surface-variant">Automated P&amp;L statements and tax-ready summaries at a tap.</p>
          </div>

          {/* Feature 5 */}
          <div className="md:col-span-4 group bg-surface-container-lowest p-card-padding rounded-2xl executive-border card-hover transition-all duration-300" data-testid="feature-analytics">
            <div className="w-12 h-12 rounded-lg bg-surface-container-high flex items-center justify-center mb-6">
              <span className="material-symbols-outlined">monitoring</span>
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-4">AI Analytics</h3>
            <p className="font-body-md text-body-md text-on-surface-variant">Predictive trends to help you stock up for seasonal peaks.</p>
          </div>

          {/* Feature 6 */}
          <div className="md:col-span-6 group bg-surface-container-lowest p-card-padding rounded-2xl executive-border card-hover transition-all duration-300" data-testid="feature-khata">
            <div className="w-12 h-12 rounded-lg bg-surface-container-high flex items-center justify-center mb-6">
              <span className="material-symbols-outlined">account_balance_wallet</span>
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-4">Customer Credit/Khata</h3>
            <p className="font-body-md text-body-md text-on-surface-variant">Automated payment reminders and complete digital ledger for every customer.</p>
          </div>

          {/* Feature 7 */}
          <div className="md:col-span-6 group bg-surface-container-lowest p-card-padding rounded-2xl executive-border card-hover transition-all duration-300" data-testid="feature-assistant">
            <div className="w-12 h-12 rounded-lg bg-surface-container-high flex items-center justify-center mb-6">
              <span className="material-symbols-outlined">smart_toy</span>
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-4">AI Assistant</h3>
            <p className="font-body-md text-body-md text-on-surface-variant">A dedicated business advisor available 24/7 to answer "How was my sale today?".</p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SevenFeatures;
